import { BaseQuery2 } from '@/utils';
import moment from 'moment';

/**
 * @startDate
 * @endDate
 * @waybillNos
*/
export const TableQuery = params => {
  return [
    {
      simpleGranularity: 'all',
      dataSource: 'route_plan_optimal_result',
      dimensions: ['__time', 'waybillNo', 'originSite', 'destinationSite', 
        'productType', 'originCenter', 'destinationCenter', 'nextSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      order: "ascending",
      limit: 1000,
      queryType: "scan",
      andFilters: [
        {key: 'scanType', value: '录单'},
        {key: 'ticket', value: '1'}
      ]
    },
    {
      // 1 结算重量	
      simpleGranularity: 'all',
      dataSource: 'route_plan_optimal_result',
      dimensions: ['waybillNo'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [],
      inFilters: [
        {key: 'waybillNo', value: params.waybillNos},
      ]
    },
    [
      {
        // 0 始发网点交件时间
        simpleGranularity: 'all',
        dataSource: 'route_plan_optimal_result',
        dimensions: ['waybillNo', '__time'],
        startDate: params.startDate,
        endDate: moment(params.endDate).add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        andFilters: [
          {key: 'isOriginCenter', value: '是'},
          {key: 'scanType', value: '分拨到车'},
          {key: 'ticket', value: '1'}
        ],
        queryType: "scan",
        limit: 1000,
        inFilters: [
          {key: 'waybillNo', value: params.waybillNos},
        ]
      },
      {
        // 1 末端网点离港时间
        simpleGranularity: 'all',
        dataSource: 'route_plan_optimal_result',
        dimensions: ['waybillNo', '__time'],
        startDate: params.startDate,
        endDate: moment(params.endDate).add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        andFilters: [
          {key: 'isDestinationCenter', value: '是'},
          {key: 'scanType', value: '分拨发车'},
          {key: 'ticket', value: '-1'}
        ],
        queryType: "scan",
        limit: 1000,
        inFilters: [
          {key: 'waybillNo', value: params.waybillNos},
        ]
      },
      {
        // 2 签收时间
        simpleGranularity: 'all',
        dataSource: 'route_plan_optimal_result',
        dimensions: ['waybillNo', '__time'],
        startDate: params.startDate,
        endDate: moment(params.endDate).add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        andFilters: [
          {key: 'scanType', value: '签收'},
          {key: 'ticket', value: '1'}
        ],
        queryType: "scan",
        limit: 1000,
        inFilters: [
          {key: 'waybillNo', value: params.waybillNos},
        ]
      },
    ]
  ]
}